import React, { FC } from 'react';

import clsx from 'clsx';

import Link from '../link/link';

export interface SelectCustomOptionsProps {
  data: {
    value: string;
    label: string;
  };
  isSelected: boolean;
}

const SelectCustomOption: FC<SelectCustomOptionsProps> = ({
  data,
  isSelected
}) => (
  <Link
    className={
      clsx(
        'languageSwitcher__link',
        isSelected && 'languageSwitcher__link--selected'
      )
    }
    to={data.value}
    variant="subNavLink"
  >
    {data.label}
  </Link>
);

export { SelectCustomOption };
export default SelectCustomOption;
